module.exports = __webpack_public_path__ + "img/home-github-hidden.efd2c366.png";